import { Box, Image } from '@chakra-ui/react';
import { useTranslation } from 'react-i18next';

import processingState from 'Asset/image/siglive-processing-state.svg';
import { TextRegular } from 'UiKit/typography';
import ProgressBar from 'UiKit/progress-bar';

import styles from './styles.module.css';

const LoadingAttendance = ({ duration }) => {
  const { t } = useTranslation('host-attendance');
  return (
    <Box className={styles['loading-attendance__container']}>
      <Image className={styles['loading-attendance__image']} src={processingState} alt="processing" />
      <Box className={styles['loading-attendance__text']}>
        <TextRegular fontSize="var(--font-body3)">{t('loading_attendance.processing')}</TextRegular>
        <TextRegular fontSize="var(--font-body3)">{t('loading_attendance.processing_duration', { duration })}</TextRegular>
      </Box>
      <Box className={styles['loading-attendance__progress--container']}>
        <ProgressBar duration={duration} showPercentage={false} />
      </Box>
    </Box>
  );
};

export default LoadingAttendance;
